import {useContext, useState} from 'react';
import {useFormik} from 'formik';
import {ThemeContext} from 'styled-components';
import {API_PATCH_TOURISTIC_SITE} from '../../../utils/api';
import touristicSiteSchema from '../../_schemas/touristic_site_schema';
import Button from '../../../_ui/_v2/components/Button';
import Loader from '../../../_ui/_v2/components/Loader';
import {TextArea, Form} from '../../../_ui/_v2/components/FormElements';
import TouristicSiteContext from '../../../_contexts/TouristicSiteContext';
import {useTranslation} from "react-i18next";

const touristicSiteSchemaForTouristicSiteAccessTransportForm = touristicSiteSchema.pick([
  'access_transport',
]);

const TouristicSiteAccessTransportForm = ({onSuccess, touristicSite = {}}) => {
  const {i18n} = useTranslation();
  const theme = useContext(ThemeContext);
  const [loading, setLoading] = useState(false);
  const { setTouristicSite } = useContext(TouristicSiteContext);

  const handleSubmitForm = (values, actions) => {
    const token = localStorage.getItem("Authorization");

    setLoading(true);
    fetch(
      API_PATCH_TOURISTIC_SITE(touristicSite.id),
      {
        method: 'PATCH',
        cache: 'default',
        body: JSON.stringify(values),
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        mode: 'cors',
      }
    )
      .then(res => res.json())
      .then(response => {
        setTouristicSite(response);
        // setLoading(false);
        onSuccess?.(response);
      })
      .catch(error => {
        console.error(error);
        setLoading(false);
      });
  };

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: touristicSiteSchemaForTouristicSiteAccessTransportForm.cast(touristicSite),
    validationSchema: touristicSiteSchemaForTouristicSiteAccessTransportForm,
    onSubmit: handleSubmitForm,
  });

  return (
    <Form onSubmit={handleSubmit}>
      <TextArea
        type="text"
        name={`access_transport[text_${i18n.language}]`}
        onChange={handleChange}
        onBlur={handleBlur}
        value={values.access_transport?.[`text_${i18n.language}`]}
        hasError={errors.access_transport?.[`text_${i18n.language}`] && touched.access_transport?.[`text_${i18n.language}`]}
        errorMessage={errors.access_transport?.[`text_${i18n.language}`]}
        placeholder={'Accès/Transports'}
        rows="8"
      />
      <Button
        rounded
        disabled={loading}
        type="submit"
        style={{
          display: 'block',
          margin: '3em auto 0 auto',
        }}
      >
        {
          loading
            ? <Loader size="1.5em" color={theme.colors.white}/>
            : 'Enregistrer'
        }
      </Button>
    </Form>
  );
};

export default TouristicSiteAccessTransportForm;